'use strict';
const contentUpgrade = require('../content/content-upgrade'),
	ThemeV2 = require('../theme/theme-v2'),
	mergeThemesV2 = require('../theme/merge-themes-v2'),
	themesIndex = require('../themes/index'),
	extractConnectors = require('./extract-connectors'),
	extractLinks = require('./extract-links'),
	MultiRootLayout = require('./multi-root-layout-v2'),
	nodeAttributeUtils = require('./node-attribute-utils'),
	invertVertically = require('./invert-vertically'),
	calculateTopDownLayout = require('./top-down/calculate-top-down-layout'),
	calculateBottomUpLayout = (rootIdea, dimensionProvider, margins) => {
		const result = calculateTopDownLayout(rootIdea, dimensionProvider, margins);
		return invertVertically(result);
	},
	defaultLayouts = {
		'standard': require('./standard/calculate-standard-layout'),
		'top-down': calculateTopDownLayout,
		'bottom-up': calculateBottomUpLayout,
		'fishbone-right-to-left': require('./fishbone/calculate-fishbone-right-to-left-layout'),
		'fishbone-left-to-right': require('./fishbone/calculate-fishbone-left-to-right-layout'),
	},
	formatResult = function (result, idea, theme, orientation) {
		nodeAttributeUtils.setThemeAttributes(result, theme);
		return {
			orientation: orientation,
			nodes: result,
			connectors: extractConnectors(idea, result, theme),
			links: extractLinks(idea, result),
			theme: idea.attr && idea.attr.theme,
			themeOverrides: Object.assign({}, idea.attr && idea.attr.themeOverrides)
		};
	};

module.exports = function calculateLayout(idea, dimensionProvider, optional) {
	const layouts = (optional && optional.layouts) || defaultLayouts,
		theme = (optional && optional.theme) || new ThemeV2(mergeThemesV2({defaultTheme: themesIndex.default})),
		multiRootLayout = new MultiRootLayout(),
		themeMargin = theme.attributeValue(['layout'], [], ['spacing'], {h: 20, v: 20}),
		marginTemp = themeMargin?.h ? themeMargin: {h: themeMargin, v: themeMargin},
		margin = Object.assign({ch: marginTemp.h, cv: marginTemp.v}, marginTemp),
		orientation = theme.attributeValue(['layout'], [], ['orientation'], 'standard'),
		calculatorName = theme.attributeValue(['layout'], [], ['calculator'], orientation),
		calculator = layouts[calculatorName] || layouts[orientation] || layouts.standard;
	idea = contentUpgrade(idea);

	Object.keys(idea.ideas).forEach((rank) => {
		const rootIdea = idea.ideas[rank],
			rootResult = calculator(rootIdea, dimensionProvider, margin, theme.layout);
		multiRootLayout.appendRootNodeLayout(rootResult, rootIdea);
	});

	return formatResult (multiRootLayout.getCombinedLayout(10, optional), idea, theme, orientation);
	// result = calculator(idea, dimensionProvider, {h: (margin.h || margin), v: (margin.v || margin)});

};

